import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import cn from 'classnames';
import { m } from 'framer-motion';
import { ReactNode } from 'react';
import { useLocales } from 'src/locales';
import { useConversationContext } from 'src/provider/ConversationContext';

type LoadingProps = {
  direction: 'up' | 'down';
  loadingMore: 'up' | 'down' | false;
};

export const LoadingMore = ({ direction, loadingMore }: LoadingProps) => {
  const { translate } = useLocales();
  return (
    <StyledLoadingContainer
      className={cn(direction, { anim: loadingMore === direction })}
    >
      <Typography variant="subtitle2">
        {translate('shared.loading.loading_more')}
      </Typography>
    </StyledLoadingContainer>
  );
};

type Props = {
  children: ReactNode;
};

export const MessageListContainer = ({ children }: Props) => {
  const { loadingMore } = useConversationContext();

  return (
    <StyledEditorStyles>
      <LoadingMore direction="up" loadingMore={loadingMore} />
      {children}
      <LoadingMore direction="down" loadingMore={loadingMore} />
    </StyledEditorStyles>
  );
};

const StyledEditorStyles = styled('div')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  overflow: 'hidden',
  gap: 1,
});

const StyledLoadingContainer = styled(m.div)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 250,
  height: 30,
  backgroundColor: theme.palette.primary.lighter,
  left: '50%',
  transform: 'translate(-50%, 0)',
  zIndex: 1,
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.enteringScreen,
  }),
  '&.up': {
    top: -30,
    borderRadius: theme.spacing(0, 0, 2, 2),
    '&.anim': {
      transform: 'translate(-50%, 34px)',
    },
  },
  '&.down': {
    bottom: -30,
    borderRadius: theme.spacing(2, 2, 0, 0),
    '&.anim': {
      transform: 'translate(-50%, -30px)',
    },
  },
}));
